import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '廿日市市で中学生向けの塾を探しています。学習塾NICKはどんな塾ですか？',
      answer: '学習塾NICKは、廿日市市大野に位置する中学生専門の学習塾です。公立高校で10年間進路指導を担当した経験豊富な講師が、一人ひとりに合わせた個別指導・少人数指導・集団講座を提供しています。廿日市市・宮島・阿品・大竹市など周辺地域からも多くの生徒が通っています。まずは無料体験授業をお試しください。'
    },
    {
      question: '廿日市市の塾の中で、学習塾NICKが選ばれる理由は何ですか？',
      answer: '廿日市市内の塾の中でも、学習塾NICKは「元公立高校教員による本物の進路指導」が最大の強みです。高校の入試業務を熟知した講師が、志望校選びから受験戦略まで的確にアドバイス。少人数制で一人ひとりに目が届き、定期テスト対策から高校受験まで一貫してサポートします。'
    },
    {
      question: '廿日市市の中学生の成績アップに対応していますか？',
      answer: 'はい、廿日市市内の各中学校（廿日市中学校・大野中学校・宮島中学校など）の定期テストに合わせた対策を実施しています。テスト2週間前から集中的な対策授業を行い、各学校の出題傾向に合わせたプリントや予想問題演習で成績アップをサポートします。'
    },
    {
      question: '無料体験はどのように申し込めますか？',
      answer: 'ホームページの無料体験申込フォーム、お電話、またはLINEからお申し込みいただけます。お気軽にお問い合わせください。体験授業は通常授業と同じ内容で、実際の雰囲気を体感していただけます。'
    },
    {
      question: '入塾テストはありますか？',
      answer: '入塾テストはございません。ただし、現在の学力を把握し、最適な指導プランを作成するため、簡単な学力診断を行わせていただきます。この診断結果は入塾の可否には関係ありませんので、ご安心ください。'
    },
    {
      question: '授業の振替はできますか？',
      answer: '体調不良や学校行事などでお休みされる場合は、事前にご連絡いただければ振替授業を実施いたします。振替可能な期間や回数については、コースによって異なりますので、詳しくはお問い合わせください。'
    },
    {
      question: '定期テスト前の対策はありますか？',
      answer: 'はい、定期テスト2週間前から集中的なテスト対策を実施しています。各中学校の出題傾向に合わせた対策プリントや、予想問題演習を行います。また、提出物のチェックや質問対応も随時行っています。'
    },
    {
      question: '高校受験の進路相談はできますか？',
      answer: '公立高校で10年間進路指導を担当してきた経験豊富な講師が、志望校選びから受験戦略まで、きめ細かくアドバイスいたします。定期的な三者面談も実施し、保護者様とも情報を共有しながら進めていきます。'
    },
    {
      question: '自習室は使えますか？',
      answer: '塾生は自習室を無料でご利用いただけます。開校時間内であればいつでも利用可能で、わからない問題があれば講師に質問することもできます。集中して学習できる環境を整えています。'
    },
    {
      question: '兄弟割引はありますか？',
      answer: 'はい、兄弟姉妹で通塾される場合は、2人目以降の授業料を10%割引させていただきます。また、友人紹介特典もございますので、詳しくはお問い合わせください。'
    },
    {
      question: '駐車場はありますか？',
      answer: '塾専用の駐車場を完備しております。送迎の際も安心してご利用いただけます。廿日市市、宮島、阿品、大竹市など周辺地域からも通いやすい立地です。'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a2332] mb-4">
            よくあるご質問
          </h2>
          <p className="text-gray-600 text-lg">
            学習塾NICKについてのよくある質問にお答えします
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-[#4a90e2] transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer hover:bg-[#f8f9fa] transition-colors"
              >
                <h4 className="text-lg font-semibold text-[#1a2332] pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-[#4a90e2] transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#faf8f5] rounded-3xl p-10 text-center">
          <h3 className="text-2xl font-bold text-[#1a2332] mb-4">
            その他のご質問はお気軽にお問い合わせください
          </h3>
          <p className="text-gray-600 mb-6 leading-relaxed">
            廿日市市大野の学習塾NICKでは、無料体験や個別相談も随時受け付けております。<br />
            お電話、LINE、お問い合わせフォームからお気軽にご連絡ください。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:0829-78-1638"
              className="bg-[#4a90e2] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#3a7bc8] transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              電話で問い合わせる
            </a>
            <a
              href="https://lin.ee/Od9tigSF"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#06c755] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#05b34a] transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill text-xl"></i>
              LINEで問い合わせる
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
